<script setup>
import { computed } from "vue";

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
});

const styles = computed(() => ({
  maxHeight: props.isOpen ? "2000px" : "0px",
}));
</script>


<template>
  <div class="accordion-content" :style="styles">
    <div class="accordion-inner">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.accordion-content {
  overflow: hidden;
  padding-left: 16px;
  padding-right: 16px;

  transition: all 0.3s ease;
}

.accordion-inner {
  padding-top: 12px;
  padding-bottom: 12px;

  font-size: 0.875rem;
  color: #6b7280;
}

</style>